import React from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Section from '@common/Section';
import Row from '@common/Row';
import Img from '@common/Image';
import Heading from '@common/Heading';
import Link from '@common/Link';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

const LinksCourses = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  return (
    <Section className={clsx({[`bg-${bgColour} pt-3 pb-5`]: bgColour })}>
      <Container>
        {(showTitle && title) && <Heading type='h2' className='fw-semibold mb-4 text-center text-uppercase'>{title}</Heading>}
        {list &&
          <Row className='row-cols-2 row-cols-lg-4 gy-3 mb-1'>
            {list.map((link, index) => (
              <div key={index} className='d-flex'>
                <Link to={link.link}  className='d-flex flex-column flex-fill bg-white border border-2 border-dark-grey-4 position-relative overflow-hidden rounded no-hover scale-1'>
                  {link.image &&
                    <Img image={link.image.gatsbyImageData} file={link.image.file}/>
                  }
                  <div className={clsx('text-black position-absolute rounded', {[`bg-${link.bgColour}`]:link.bgColour})} style={{top: 15, left: 15, padding: 5}}>{link.subtitle}</div>
                  <div className='d-flex flex-column flex-fill justify-content-between p-1'>
                    <div className='fs-24 ff-inter fw-normal text-black mb-3'>{link.title}</div>
                    <div className='fw-medium align-items-center'>
                      <span style={{marginRight: '5px'}}>{link.linkCopy}</span>
                      <FontAwesomeIcon icon={faChevronRight} size='sm'/>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </Row>
        }
        <Row className='mt-4'>
          <Link to='/academy/catalog' className='d-flex justify-content-center text-black'>
            <div className='fs-24 fw-medium align-items-center'>
              <span style={{marginRight: '5px'}}>{'See more courses'}</span>
              <FontAwesomeIcon icon={faChevronRight} size='sm'/>
            </div>
          </Link>
        </Row>
      </Container>
    </Section>
  )
}

export default LinksCourses
